module.exports = "/images/vendor/flag-icon-css/flags/1x1/ws.svg?3ea6d44f91f0accab1ba37b5b7a80f55";